// extracted by mini-css-extract-plugin
export default {"cardsContainer":"styles_cardsContainer__dNHiF","checkbox_red":"styles_checkbox_red__qwmhS","dayTabs":"styles_dayTabs__4vU7-","emptyDataContainer":"styles_emptyDataContainer__AEYPI"};